'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _gsap = require('gsap');

var _shape = require('./shape.css');

var _shape2 = _interopRequireDefault(_shape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogoShape = function (_Component) {
  _inherits(LogoShape, _Component);

  function LogoShape() {
    _classCallCheck(this, LogoShape);

    var _this = _possibleConstructorReturn(this, (LogoShape.__proto__ || Object.getPrototypeOf(LogoShape)).call(this));

    _this.state = {};
    return _this;
  }

  _createClass(LogoShape, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var isPiano = this.props.isPiano;


      if (isPiano) {
        this.initAudioAPI();
      }
    }
  }, {
    key: 'initAudioAPI',
    value: function initAudioAPI() {
      function BufferLoader(context, urlList, callback) {
        this.context = context;
        this.urlList = urlList;
        this.onload = callback;
        this.bufferList = [];
        this.loadCount = 0;
      }

      BufferLoader.prototype.loadBuffer = function (url, index) {
        // Load buffer asynchronously
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'arraybuffer';

        var loader = this;

        request.onload = function () {
          // Asynchronously decode the audio file data in request.response
          loader.context.decodeAudioData(request.response, function (buffer) {
            if (!buffer) {
              console.log('error decoding file data: ' + url);
              return;
            }
            loader.bufferList[index] = buffer;
            if (++loader.loadCount === loader.urlList.length) {
              loader.onload(loader.bufferList);
            }
          }, function (error) {
            console.error('decodeAudioData error', error);
          });
        };

        request.onerror = function () {
          console.log('BufferLoader: XHR error');
        };

        request.send();
      };

      BufferLoader.prototype.load = function () {
        for (var i = 0; i < this.urlList.length; ++i) {
          this.loadBuffer(this.urlList[i], i);
        }
      };
      var context = void 0;
      var bufferLoader = void 0;

      context = window.audioCTXT;

      bufferLoader = new BufferLoader(context, ['/audio/piano/1.wav', '/audio/piano/2.wav', '/audio/piano/3.wav', '/audio/piano/4.wav', '/audio/piano/5.wav', '/audio/piano/6.wav', '/audio/piano/7.wav', '/audio/piano/8.wav', '/audio/piano/9.wav', '/audio/piano/10.wav', '/audio/piano/11.wav', '/audio/piano/12.wav', '/audio/piano/3c.mp3', '/audio/piano/3d.mp3', '/audio/piano/3e.mp3'], finishedLoading.bind(this));

      bufferLoader.load();

      function finishedLoading(bufferList) {
        this.setState({
          context: context,
          bufferLoader: bufferLoader,
          bufferList: bufferList
        });
      }
    }
  }, {
    key: 'playSound',
    value: function playSound(index) {
      var isPiano = this.props.isPiano;


      if (isPiano) {
        var _state = this.state,
            context = _state.context,
            bufferList = _state.bufferList;

        var source1 = context.createBufferSource();

        source1.buffer = bufferList[index];

        source1.connect(context.destination);
        source1.start(0);
      }
    }
  }, {
    key: 'mouseEnter',
    value: function mouseEnter(el) {
      var isPiano = this.props.isPiano;


      if (isPiano) {
        _gsap.TweenLite.to(el, 0.3, {
          transformOrigin: '50% 50%',
          scaleY: 0.95
        });
      }
    }
  }, {
    key: 'mouseLeave',
    value: function mouseLeave(el) {
      var isPiano = this.props.isPiano;


      if (isPiano) {
        _gsap.TweenLite.to(el, 0.6, {
          transformOrigin: '50% 50%',
          scaleY: 1
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isMoving = _props.isMoving,
          isHome = _props.isHome,
          css = _props.css;

      var svgClass = isMoving ? _shape2.default.svg : _shape2.default.svgStill;
      var holderClass = isHome ? _shape2.default.holderHome : _shape2.default.holder;

      return _react2.default.createElement(
        'div',
        { className: holderClass, style: css },
        _react2.default.createElement(
          'svg',
          { viewBox: '0 0 1689.6 1634.1', className: svgClass },
          _react2.default.createElement('path', {
            id: 'shape1',
            className: _shape2.default.st0,
            d: 'M0.8,1168.8l0-211.3c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1l0,211.3 c0,22.7-18.4,41.1-41.1,41.1S0.8,1191.5,0.8,1168.8z',
            ref: 'path1'
          }),
          _react2.default.createElement('path', {
            id: 'shape2',
            className: _shape2.default.st1,
            d: 'M147.1,1266.3l0-406.4c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1l0,406.4 c0,22.7-18.4,41.1-41.1,41.1C165.5,1307.4,147.1,1289,147.1,1266.3z',
            ref: 'path2'
          }),
          _react2.default.createElement('path', {
            id: 'shape3',
            className: _shape2.default.st2,
            d: 'M292.1,1592.2l0-634c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1l0,634 c0,22.7-18.4,41.1-41.1,41.1C310.4,1633.4,292.1,1615,292.1,1592.2z',
            ref: 'path3'
          }),
          _react2.default.createElement('path', {
            id: 'shape4',
            className: _shape2.default.st3,
            d: 'M435.6,1532.1l0-513.7c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1l0,513.7 c0,22.7-18.4,41.1-41.1,41.1C453.9,1573.2,435.6,1554.8,435.6,1532.1z',
            ref: 'path4'
          }),
          _react2.default.createElement('path', {
            id: 'shape5',
            className: _shape2.default.st4,
            d: 'M580.5,1341.9V925.7c0-22.5,19.5-41.1,42.5-41.1c23,0,42.5,18.7,42.5,41.1v416.2 c0,22.5-19.5,41.1-42.5,41.1C600,1383,580.5,1364.4,580.5,1341.9z',
            ref: 'path5'
          }),
          _react2.default.createElement('path', {
            id: 'shape6',
            className: _shape2.default.st5,
            d: 'M726.9,1096.6V859.9c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1l0,236.7 c0,22.7-18.4,41.1-41.1,41.1C745.2,1137.7,726.9,1119.3,726.9,1096.6z',
            ref: 'path6'
          }),
          _react2.default.createElement('path', {
            id: 'shape7',
            className: _shape2.default.st6,
            d: 'M871.8,1049.1l0-368.1c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1v368.1 c0,22.7-18.4,41.1-41.1,41.1C890.2,1090.3,871.8,1071.9,871.8,1049.1z',
            ref: 'path7'
          }),
          _react2.default.createElement('path', {
            id: 'shape8',
            className: _shape2.default.st7,
            d: 'M1022.4,897.8l-7.1-362.4c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1l7.1,362.4 c0,22.7-18.4,41.1-41.1,41.1C1040.7,938.9,1022.4,920.5,1022.4,897.8L1022.4,897.8z',
            ref: 'path8'
          }),
          _react2.default.createElement('path', {
            id: 'shape9',
            className: _shape2.default.st8,
            d: 'M1167.3,746.4l0-342.4c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1l0,342.4 c0,22.7-18.4,41.1-41.1,41.1C1185.7,787.5,1167.3,769.1,1167.3,746.4z',
            ref: 'path9'
          }),
          _react2.default.createElement('path', {
            id: 'shape10',
            className: _shape2.default.st9,
            d: 'M1313.7,790.9l0-558.8c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1l0,558.8 c0,22.7-18.4,41.1-41.1,41.1C1332.1,832.1,1313.7,813.7,1313.7,790.9z',
            ref: 'path10'
          }),
          _react2.default.createElement('path', {
            id: 'shape11',
            className: _shape2.default.st10,
            d: 'M1462.8,670.1l0-628.2c0-22.7,18.4-41.1,41.1-41.1c22.7,0,41.1,18.4,41.1,41.1l0,628.2 c0,22.7-18.4,41.1-41.1,41.1C1481.2,711.2,1462.8,692.8,1462.8,670.1z',
            ref: 'path11'
          }),
          _react2.default.createElement('path', {
            id: 'shape12',
            className: _shape2.default.st11,
            d: 'M1649.5,567.5c22,0,39.4-17.8,39.4-40.1V269.5c0-22.3-17.3-40.1-39.4-40.1 c-22,0-39.4,17.8-39.4,40.1l0,257.9C1610.2,549.7,1627.5,567.5,1649.5,567.5z',
            ref: 'path12'
          }),
          _react2.default.createElement('rect', { x: '1.6', y: '912', width: '82.2', height: '298.2',
            onClick: function onClick() {
              _this2.playSound(0);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path1);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path1);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '148', y: '819', width: '82.2', height: '488.7',
            onClick: function onClick() {
              _this2.playSound(1);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path2);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path2);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '292.9', y: '916.6', width: '82.2', height: '717.1',
            onClick: function onClick() {
              _this2.playSound(2);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path3);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path3);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '436.4', y: '978.5', width: '82.2', height: '595',
            onClick: function onClick() {
              _this2.playSound(3);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path4);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path4);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '581.3', y: '884.8', width: '85.1', height: '498.5',
            onClick: function onClick() {
              _this2.playSound(4);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path5);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path5);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '727.7', y: '819', width: '82.2', height: '319',
            onClick: function onClick() {
              _this2.playSound(5);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path6);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path6);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '872.6', y: '640.2', width: '82.2', height: '450.4',
            onClick: function onClick() {
              _this2.playSound(6);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path7);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path7);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '1016.1', y: '494.5', width: '89.2', height: '444.7',
            onClick: function onClick() {
              _this2.playSound(7);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path8);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path8);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '1168.1', y: '363.1', width: '82.2', height: '424.7',
            onClick: function onClick() {
              _this2.playSound(8);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path9);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path9);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '1314.5', y: '191.3', width: '82.2', height: '641.1',
            onClick: function onClick() {
              _this2.playSound(9);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path10);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path10);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '1463.6', y: '1', width: '82.2', height: '710.5',
            onClick: function onClick() {
              _this2.playSound(10);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path11);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path11);
            },
            opacity: '0'
          }),
          _react2.default.createElement('rect', { x: '1611', y: '229.6', width: '78.7', height: '338.1',
            onClick: function onClick() {
              _this2.playSound(11);
            },
            onMouseEnter: function onMouseEnter() {
              _this2.mouseEnter(_this2.refs.path12);
            },
            onMouseLeave: function onMouseLeave() {
              _this2.mouseLeave(_this2.refs.path12);
            },
            opacity: '0'
          })
        )
      );
    }
  }]);

  return LogoShape;
}(_react.Component);

exports.default = LogoShape;


//////////////////
// WEBPACK FOOTER
// ./src/components/LogoShape/LogoShape.js
// module id = 146
// module chunks = 1